import { CSRF, getData, getElement } from "../../../../helpers";
import { Dt } from "../../../../plugins/datatable";
import { EntityModal as Entity } from "./modals/store";

class EntityModule extends HTMLElement {
    connectedCallback() {
        this.load();
    }

    load() {
        // console.log(this);
        const DtElement = getElement("[data-table=dt]", this);
        const BtnNew = getElement("[name=new]", this); // Identificar el botón para crear

        // Start DataTable
        let configDt = {
            processing: true, // Procesar ajax
            serverSide: true, // Mejorar velocidad ajax registros por página
            scrollY: "520px", // Define la altura de desplazamiento para el cuerpo de la tabla
            scrollCollapse: true, // Permite que el contenido colapse dentro del área definida
            fixedHeader: true, // Mantiene el encabezado visible al hacer scroll
        };

        configDt.ajax = {
            url: getData("entitiesUrlDt"),
            type: "POST",
            beforeSend: function (request) {
                request.setRequestHeader("X-CSRF-TOKEN", CSRF);
            },
        };
        // Columnas del AJAX
        configDt.columns = [
            { data: "DT_RowIndex", width: "3%", className: "text-center" },
            { data: "name" },
            {
                data: "status",
                width: "5%",
                className: "text-center",
                orderable: false,
            },
            {
                data: "buttons",
                width: "5%",
                className: "text-center",
                orderable: false,
            },
        ];

        const DtAps = new Dt(configDt);
        DtAps.dataTable(DtElement);
        // End DataTable

        // Eventos
        BtnNew?.addEventListener("click", (e) => {
            Entity.create(
                getData(BtnNew, "data-bs-target"),
                getData(BtnNew, "title"),
                getData(BtnNew, "data-url")
            );
        });

        DtElement.addEventListener("click", (e) => {
            const BtnEdit = e.target.closest(".edit");

            if (BtnEdit) {
                Entity.edit(
                    getData(BtnEdit, "data-bs-target"),
                    getData(BtnEdit, "title"),
                    getData(BtnEdit, "data-url"),
                    getData(BtnEdit, "data-data")
                );
            }
        });
    }
}

window.customElements.define("entity-module", EntityModule, {
    extends: "section",
});
